import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import ComboAbmArtArticulos_Reservables from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos_Reservables";
import { LVForm } from "../../Componentes/Basicos/LVForm";
import { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import { DateBox, NumberBox } from "devextreme-react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_ABM_ART_Articulos_Reservables_AforoReservado_Insertar, function_ABM_ART_Articulos_Reservables_AforoReservado_Listar } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos_Reservables_AforoReservado";
import { Column } from "devextreme-react/gantt";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";

export const VEN_Reservas_CambioDeHorariosAforos_HorariosReservados = () => {

  let Codigo = useParams()

  const { ABM_ART_Articulos_Reservables: { function_ABM_ART_Articulos_Reservables_Leer, function_ABM_ART_Articulos_Reservables_Modificar } } = require('neftis7_apicaller');
  const [codigoArticulo, setCodigoArticulo] = useState(null);
  const [vigenciaDesde, setVigenciaDesde] = useState(new Date());
  const [vigenciaHasta, setVigenciaHasta] = useState(new Date());
  const [data, setData] = useState([])

  const [cantidadReservada, setCantidadReservada] = useState(0);
  const [horaDesde, setHoraDesde] = useState(0);
  const [horaHasta, setHoraHasta] = useState(0);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const getData = async (codArticulo) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_ABM_ART_Articulos_Reservables_AforoReservado_Listar(codArticulo);
      setData(resultData.data)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  const onValueChangedCodigoArticulo = async (e) => {
    //const Articulo = await function_ABM_ART_Articulos_Reservables_Leer(e.value)

    setCodigoArticulo(e.value)

    setVigenciaDesde(new Date())
    setVigenciaHasta(new Date())

    setCantidadReservada(0)
    setHoraDesde(0)
    setHoraHasta(0)

    getData(e.value)
  }

  const handleOnValueChangedFechaDesde = async (e) => {
    setVigenciaDesde(e.value)
  }

  const handleOnValueChangedFechaHasta = async (e) => {
    setVigenciaHasta(e.value)
  }


  const onValueChangedCantidad = async (e) => {
    setCantidadReservada(e.value)
  }

  const onValueChangedHoraDesde = async (e) => {
    setHoraDesde(e.value)
  }

  const onValueChangedHoraHasta = async (e) => {
    setHoraHasta(e.value)
  }

  const onClickGuardar = () => {

    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      const guardar = async () => {
        await function_ABM_ART_Articulos_Reservables_AforoReservado_Insertar(codigoArticulo, horaDesde, horaHasta, cantidadReservada, vigenciaDesde, vigenciaHasta)
      }

      guardar();

      alert("Se ha guardado correctamente el Aforo Reservado");

      getData(codigoArticulo)
    } catch (error) {
      alert("Hubo problemas guardando el Aforo Reservado.");
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  const formatFecha = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'GMT' };
    const date = new Date(dateString);
    return date.toLocaleDateString('es-AR', options);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }
  }, []);

  return (
    <PaginaCreacionLibre
      Titulo="RESERVAS INTERNAS"
    >
      <LVForm colCount={2} >
        <SimpleItem colSpan={2}>
          <ComboAbmArtArticulos_Reservables
            value={codigoArticulo}
            ancho={300}
            onValueChanged={onValueChangedCodigoArticulo} />
        </SimpleItem>

        <SimpleItem colSpan={2}>
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer">
            <Column caption="Fecha Desde" dataField="VigenciaDesde" width="120" alignment="Right" dataType="date" format={formatFecha} />
            <Column caption="Fecha Hasta" dataField="VigenciaHasta" width="120" alignment="Right" dataType="date" format={formatFecha} />
            <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Right" dataType="string" />
            <Column caption="Reserva" dataField="CantidadReservada" width="120" alignment="Right" dataType="number" />
            <Column caption="Hora" dataField="Hora" width="90" alignment="Right" dataType="string" />
          </LVGridCabecera>
        </SimpleItem>

        <GroupItem colCount={2} caption={"VIGENCIA"} >
          <SimpleItem>
            DESDE:
            <DateBox displayFormat="dd/MM/yyyy"
              value={vigenciaDesde}
              onValueChanged={handleOnValueChangedFechaDesde}
              width={120} >
            </DateBox>
          </SimpleItem>

          <SimpleItem>
            HASTA:
            <DateBox displayFormat="dd/MM/yyyy"
              value={vigenciaHasta}
              onValueChanged={handleOnValueChangedFechaHasta}
              width={120} >
            </DateBox>
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={3} caption={"RANGO"} >
          <SimpleItem >
            <NumberBox value={horaDesde}
              onValueChanged={onValueChangedHoraDesde} />
            <Label text="HORA DESDE" />
          </SimpleItem>

          <SimpleItem >
            <NumberBox value={horaHasta}
              onValueChanged={onValueChangedHoraHasta} />
            <Label text="HORA HASTA" />
          </SimpleItem>

          <SimpleItem >
            <NumberBox value={cantidadReservada}
              onValueChanged={onValueChangedCantidad} />
            <Label text="CANTIDAD" />
          </SimpleItem>
        </GroupItem>

        <SimpleItem colSpan={2}>
          <LVButtonAccion
            Disabled={cierreEnProceso} Texto="GUARDAR" Ancho={'100%'} onClick={onClickGuardar} />
        </SimpleItem>

      </LVForm>
    </PaginaCreacionLibre >
  );
}
